exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 1024px) {\r\n    .profile-settings{\r\n        display: none;\r\n    }\r\n }\r\n\r\n @media only screen and (max-width: 767px) {\r\n    .logo-footer-white {\r\n        float: unset;\r\n    }\r\n}\r\n\r\n .logo-footer-white {\r\n    float: right;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/corporate/corporate.component.css
// module id = ../../../../../src/app/corporate/corporate.component.css
// module chunks = main